var _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum12Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 23,
    viewBox: "0 0 59 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7789_97161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.244507 23V0H31.1558V5.36668L28.2279 5.36665L28.4584 3.29259H25.1613L24.9214 5.36665L24.1002 13.7979L31.1558 13.7979V23H0.244507Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7789_97161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03355 23L9.29255 20.5357L15.4195 17.25L15.7649 13.9643L5.97723 4.92857L6.32257 1.64286H11.2783L11.4509 0H18.8845H26.318L26.1453 1.64286H31.101L30.7557 4.92857L19.0687 13.9643L18.7233 17.25L24.1596 20.5357L23.9006 23H16.4671H9.03355ZM11.9315 3.28571H8.62775L8.54141 4.10714L11.5862 6.57143L11.9315 3.28571ZM25.1467 3.28571H28.4505L28.3642 4.10714L24.8014 6.57143L25.1467 3.28571Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1073 1.76416L19.3888 1.76416L18.389 11.3123L16.7835 11.3123L17.544 4.05967H17.5299L16.2765 5.24263H16.2625L16.4455 3.49635L18.1073 1.76416Z",
    fill: "#161C31"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7789_97161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 31,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0891 5.36675V0H58.7554V23H28.0891V13.8L38.2176 13.8L39.0732 5.36683L39.2982 3.30382H35.9946L35.766 5.36681L28.0891 5.36675Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7789_97161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3976 23L36.6566 20.5357L42.7836 17.25L43.1289 13.9643L33.3412 4.92857L33.6866 1.64286H38.6423L38.8149 0H46.2485H53.682L53.5094 1.64286H58.4651L58.1197 4.92857L46.4327 13.9643L46.0873 17.25L51.5237 20.5357L51.2646 23H43.8311H36.3976ZM39.2956 3.28571H35.9918L35.9054 4.10714L38.9502 6.57143L39.2956 3.28571ZM52.5107 3.28571H55.8145L55.7282 4.10714L52.1654 6.57143L52.5107 3.28571Z",
    fill: "#D9D7CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8696 11.3122L43.0527 9.55186C43.1654 8.49564 43.5456 8.01682 44.5032 7.05919L45.475 6.10155C46.0242 5.55232 46.1791 5.2425 46.2495 4.45386L46.334 3.66522C46.3903 3.1019 46.0946 2.94699 45.7707 2.94699C45.4327 2.94699 45.1511 3.1019 45.0947 3.65114L44.968 4.89043L43.5034 4.89043L43.6442 3.55256C43.7709 2.31326 44.5173 1.65137 45.8693 1.65137C47.4043 1.65137 48.0521 2.39776 47.8972 3.80605L47.7986 4.73552C47.686 5.7354 47.4466 6.15789 46.5312 7.07327L45.4186 8.15765C44.968 8.60831 44.6441 8.93221 44.5737 9.60819L44.5314 10.0025L47.179 10.0025L47.0382 11.3122L42.8696 11.3122Z",
    fill: "#161C31"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0779 13.4963L27.2959 11.3645H30.009L30.324 8.43335H32.6011L32.2861 11.3645H34.9751L34.757 13.4963H32.0681L31.7532 16.4274H29.4761L29.791 13.4963H27.0779Z",
    fill: "#798BB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum12Updated);
export default __webpack_public_path__ + "static/media/sum-1-2-updated.89e642ac081ed4efe9afa54b860428bf.svg";
export { ForwardRef as ReactComponent };